<script setup>
import { useRoute } from '@js/utils/route';
import { ref } from 'vue';

const { googleAdsProductManagement, tenant, callback } = defineProps({
    googleAdsProductManagement: {
        type: Object,
        required: true,
    },
    tenant: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

const loading = ref(false);

function action() {
    loading.value = true;

    axios
        .post(
            route(
                'front.projectManagement.sea.postResetProductManagementItems',
                {
                    tenant: tenant.id,
                    googleAdsProductManagement: googleAdsProductManagement.id,
                },
            ),
        )
        .then(() => {
            if (callback) {
                callback();
            }
        })
        .finally(() => {
            loading.value = false;
        })
        .catch((error) => {
            console.error(error);
        });
}
</script>

<template>
    <slot name="button" :action="action" :loading="loading" />
</template>
